import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DiscountCoupon } from '../models/discount-coupon';
import { InMemoryDiscountCoupons } from '../models/in-memory-discount-coupons';
import { DiscountService } from './discount.service';

@Injectable()
export class DiscountInMemoryService implements DiscountService {

  private _inMemoryDiscountCoupons = new InMemoryDiscountCoupons();

  getCouponDiscounts(
    coupons: string[],
    productIds: number[],
    prices: number[],
    quantities: number[],
    bookingDate: string,
    bookingFromTime: number,
    bookingToTime: number,
  ): Observable<DiscountCoupon[]> {
    return of(coupons.map(coupon => this._inMemoryDiscountCoupons.items.find(item => item.name === coupon)));
  }

  getGuestCouponDiscounts(
    coupons: string[],
    productIds: number[],
    prices: number[],
    quantities: number[],
    bookingDate: string,
    bookingFromTime: number,
    bookingToTime: number,
  ): Observable<DiscountCoupon[]> {
    return of(coupons.map(coupon => this._inMemoryDiscountCoupons.items.find(item => item.name === coupon)));
  }
}
